import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Box } from '@mui/material';
import React, { useEffect } from 'react';

declare interface Props {
  onClose: (ok: boolean) => void;
  open: boolean;
  cancelText?: string;
  cancelHidden?: boolean;
  okText?: string;
  okDisabled?: boolean;
  title: string;
  maxWidth?: false | 'xs' | 'sm' | 'md' | 'lg' | 'xl';
  keyCode?: string;
  children?: React.ReactNode;
  titleIconStart?: React.ReactNode;
  okButtonId?: string;
  onEntering?: () => void;
}
const ConfirmationDialog: React.FC<React.PropsWithChildren<Props>> = ({
  onClose,
  open,
  children,
  cancelText,
  okText,
  title,
  maxWidth,
  okDisabled,
  cancelHidden,
  keyCode,
  titleIconStart,
  okButtonId,
  onEntering,
}) => {
  useEffect(() => {
    if (keyCode == 'Enter') {
      handleOk();
    }
    if (keyCode == 'Escape') {
      handleCancel();
    }
  }, [keyCode]);

  const handleCancel = () => {
    onClose(false);
  };

  const handleOk = () => {
    onClose(true);
  };

  const onKeyDown = (event: React.KeyboardEvent<HTMLElement>): void => {
    if (event.key === 'Enter') {
      event.preventDefault();
      event.stopPropagation();
      handleOk();
    }
  };

  return (
    <Dialog maxWidth={maxWidth || 'xs'} fullWidth aria-labelledby="confirmation-dialog-title" open={open} TransitionProps={{ onEntering: onEntering }}>
      <DialogTitle id="confirmation-dialog-title">
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          {titleIconStart && <Box sx={{ display: 'flex', alignItems: 'center', pr: 1 }}>{titleIconStart}</Box>}
          <Box>{title}</Box>
        </Box>
      </DialogTitle>
      <DialogContent dividers>{children}</DialogContent>
      <DialogActions>
        {!cancelHidden || null ? (
          <Button autoFocus onClick={handleCancel} variant="outlined" color="primary">
            {cancelText || 'Cancel'}
          </Button>
        ) : null}
        <Button onClick={handleOk} id={okButtonId} variant="outlined" onKeyDown={(e) => onKeyDown(e)} color="primary" disabled={okDisabled}>
          {okText || 'OK'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmationDialog;
